import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { MatchPreference } from "PFTypes";
import React from "react";
import { useTranslation } from "react-i18next";

import { PREFERENCE_ICON_TABLE } from "../../../constants";
import css from "./matched_preference.scss";

type MatchedPreferenceProps = { match: MatchPreference; label?: string };

export const MatchedPreference = ({ match, label }: MatchedPreferenceProps) => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.matchPreferences" });

  return (
    <div className={css.matchPreference}>
      <Icon name={PREFERENCE_ICON_TABLE[match]} />
      <Typography variant="bodyRegular">{label || t(match)}</Typography>
    </div>
  );
};
